var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnavProjects(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.6667,
    height: 16.6667,
    viewBox: "0 0 16.6667 16.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 7.5H2.5M14.1667 7.5C15.0871 7.5 15.8333 8.24619 15.8333 9.16667V14.1667C15.8333 15.0871 15.0871 15.8333 14.1667 15.8333H2.5C1.57953 15.8333 0.833333 15.0871 0.833333 14.1667V9.16667C0.833333 8.24619 1.57953 7.5 2.5 7.5M14.1667 7.5V5.83333C14.1667 4.91286 13.4205 4.16667 12.5 4.16667M2.5 7.5V5.83333C2.5 4.91286 3.24619 4.16667 4.16667 4.16667M4.16667 4.16667V2.5C4.16667 1.57953 4.91286 0.833333 5.83333 0.833333H10.8333C11.7538 0.833333 12.5 1.57953 12.5 2.5V4.16667M4.16667 4.16667H12.5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavProjects);
export default __webpack_public_path__ + "static/media/unav-projects.aca623982c22c0610e76d92dd2660a1b.svg";
export { ForwardRef as ReactComponent };